import request from '@/utils/request'

export function listUserGroups() {
  return request({
    url: '/user-groups',
    method: 'get'
  })
}

export function saveUserGroup(data) {
  return request({
    url: '/user-groups',
    method: 'post',
    data
  })
}

export function deleteUserGroup(id) {
  return request({
    url: `/user-groups/${id}`,
    method: 'delete'
  })
}

export function addUsersToGroup(groupId, userIds) {
  return request({
    url: `/user-groups/${groupId}/users`,
    method: 'post',
    data: userIds
  })
}

export function removeUserFromGroup(groupId, userId) {
  return request({
    url: `/user-groups/${groupId}/users/${userId}`,
    method: 'delete'
  })
}

export function batchUserGroups(userIds) {
  return request({
    url: '/user-groups/batch-user-groups',
    method: 'post',
    data: userIds
  })
}

export function listGroupUsers(groupId) {
  return request({
    url: `/user-groups/${groupId}/users`,
    method: 'get'
  })
}
